import type { ReactNode } from "react";
import type { ModuleId } from "@frontier/content/definitions";

const icons: Record<ModuleId | "boost", ReactNode> = {
  boost: (
    <>
      <path d="m10 24 10-13 10 13M13 30l7-9 7 9M20 11V5" />
      <path d="M20 30v5" opacity=".5" />
    </>
  ),
  barrier: (
    <>
      <path d="m20 5 13 6v10c0 7-13 14-13 14S7 28 7 21V11Z" />
      <path d="m20 11 7 4v7l-7 6-7-6v-7Z" opacity=".5" />
    </>
  ),
  repair: (
    <>
      <path d="M16 7h8v9h9v8h-9v9h-8v-9H7v-8h9Z" />
      <path d="M4 4h8M4 4v8m32-8h-8m8 0v8" opacity=".4" />
    </>
  ),
  mine: (
    <>
      <circle cx="20" cy="20" r="8" />
      <circle cx="20" cy="20" r="2" />
      <path d="M20 4v8m0 16v8M4 20h8m16 0h8M9 9l6 6m10 10 6 6M9 31l6-6m10-10 6-6" />
    </>
  ),
  volley: (
    <>
      <path d="m10 32 7-12-7-12m10 24 7-12-7-12M6 20h28" />
      <path d="M29 6h6v6m0 16v6h-6" opacity=".4" />
    </>
  ),
  jammer: (
    <>
      <path d="M20 13v22m-7 0h14M12 8a12 12 0 0 0 0 18m16-18a12 12 0 0 1 0 18M7 3a19 19 0 0 0 0 28m26-28a19 19 0 0 1 0 28" />
      <circle cx="20" cy="13" r="3" />
    </>
  ),
  interceptor: (
    <>
      <circle cx="20" cy="20" r="12" />
      <path d="M20 2v10m0 16v10M2 20h10m16 0h10m-14-4-8 8m0-8 8 8" />
    </>
  ),
  "repair-field": (
    <>
      <circle cx="20" cy="20" r="16" strokeDasharray="4 3" />
      <path d="M16 11h8v5h5v8h-5v5h-8v-5h-5v-8h5Z" />
    </>
  ),
  scan: (
    <>
      <circle cx="20" cy="20" r="15" />
      <circle cx="20" cy="20" r="8" opacity=".5" />
      <path d="M20 20 30 9M20 5v5M5 20h5" />
      <circle cx="25" cy="26" r="2" />
    </>
  ),
};

export function AbilityIcon({ kind }: { kind: ModuleId | "boost" }) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      {icons[kind]}
    </svg>
  );
}
